import React from 'react'
import {Layout, Row, Table, Tag, Col, Button} from 'antd';
import {API_URI, TOKENADMIN} from "../../constants/ApiConfig";
import {Link} from 'react-router-dom';
import axios from "axios";
const {Content} = Layout;
//const axios = require('axios');



async function getNewToken(user,passe){
    const res = await axios.post(API_URI + '/api/authentication_token', {
        "email": user,
        "password": passe
    });

   await localStorage.setItem('tokenAdmin', res.data.token);
}

export default async  function getTokenAPi() {

    //localStorage.removeItem('tokenAdmin');
    // tester si le token est défini
    if(!TOKENADMIN){
       //getNewToken()
    }
    getNewToken()
    
    var token = localStorage.getItem('tokenAdmin');
    console.log(token)
    return token
}




